// @system — "On this page": anchor list built from the h2 headings of `content_html`.
import { text } from '@/config'

/**
 * @typedef {object} TableOfContentsProps
 * @property {import('./article-helpers').ArticleHeading[]} headings
 */

/** @param {TableOfContentsProps} props */
export function TableOfContents({ headings }) {
  if (headings.length === 0) return null
  return (
    <nav aria-label={text.blog.onThisPage} className="space-y-3" data-testid="toc">
      <h3 className="text-sm font-semibold text-brand-text-muted uppercase tracking-wider">
        {text.blog.onThisPage}
      </h3>
      <ol className="space-y-1 border-l border-brand-border">
        {headings.map((h) => (
          <li key={h.id}>
            <a
              href={`#${h.id}`}
              className="-ml-px flex min-h-6 items-center border-l-2 border-transparent py-1 pl-3 text-sm text-brand-text-muted transition-colors hover:border-brand-primary hover:text-brand-primary"
            >
              {h.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  )
}
